import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'
import {
  PRO_ASSISTANT_PLATFORM_ROLE,
  PRO_PLATFORM_ROLE,
  isProWorkspaceUser,
} from '@/shared/lib/staff-capabilities'

function deskRoleLabel(roles: readonly string[]): string {
  if (roles.includes(PRO_ASSISTANT_PLATFORM_ROLE)) return 'PRO assistant'
  if (roles.includes(PRO_PLATFORM_ROLE)) return 'PRO'
  return 'PRO desk'
}

/** Shows the signed-in person on every PRO page so the desk owner can see who is working. */
export function ProWorkingAsBanner() {
  const session = useMeSessionQuery()
  const roles = session.data?.roles ?? []
  const capabilities = session.data?.capabilities ?? []
  if (!isProWorkspaceUser(roles, capabilities)) return null

  const name = session.data?.displayName?.trim() || 'Signed-in user'
  return (
    <div className="mb-4 rounded-xl border border-brand-primary/30 bg-brand-primary/5 px-4 py-2 text-sm text-text-primary">
      Working as <span className="font-semibold">{name}</span>
      <span className="text-text-secondary"> · {deskRoleLabel(roles)}</span>
    </div>
  )
}
